import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import { refFetch } from "../actions";
import LoadingPage from "./LoadingPage";
import { firebase } from "../firebase/firebase";

class Reference extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      description: "",
      image: "",
      edit: false,
      id: null,
    };
    props.refFetch();
  }

  onOpenModal(item) {
    this.setState({
      open: true,
      image: item[1].image,
      description: item[1].description,
      id: item[0],
    });
  }

  onCloseModal() {
    this.setState({ open: false });
  }

  renderItems(items) {
    return Object.entries(items).map((item, i) => (
      <li key={i} onClick={() => this.onOpenModal(item)}>
        <div className="rig-cell">
          <img className="rig-img rig2-img" src={item[1].image} />
          <span className="rig-overlay" />
          <span className="rig-text">{item[1].description}</span>
        </div>
      </li>
    ));
  }

  render() {
    const { open, description, image, edit, id } = this.state;
    const { items } = this.props;
    if (items) {
      return (
        <div>
          <ul id="rig" className="rig2">
            {this.renderItems(items)}
          </ul>
          <Modal open={open} onClose={() => this.onCloseModal()} center>
            <img style={{ maxWidth: "calc(800px - 2.4rem)" }} src={image} />

            {edit ? (
              <textarea
                style={{ width: "100%" }}
                onChange={e => this.setState({ description: e.target.value })}
                value={description}
              />
            ) : (
              <div style={{ whiteSpace: "pre" }}>{description}</div>
            )}
            {edit ? (
              <div>
                <button
                  onClick={() => {
                    this.onCloseModal();
                    this.setState({ edit: false });
                  }}>
                  Mégse
                </button>
                <button
                  onClick={() =>
                    firebase
                      .database()
                      .ref("Reference")
                      .child(id)
                      .update({ description })
                      .then(() => {
                        alert("Szerkesztve!");
                        location.reload();
                      })
                  }>
                  Mentés
                </button>
              </div>
            ) : (
              <button
                style={{ display: this.props.uid ? "initial" : "none" }}
                onClick={() => this.setState({ edit: true })}>
                Szerkesztés
              </button>
            )}
          </Modal>
        </div>
      );
    } else {
      return <LoadingPage />;
    }
  }
}
const mapStateToProps = state => {
  return {
    items: state.fetch.refs,
    uid: state.auth.uid,
  };
};

export default connect(
  mapStateToProps,
  { refFetch }
)(Reference);



// WEBPACK FOOTER //
// ./src/components/Reference.js